<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="mw-970 mx-auto">
                    <div class="c-section">
                        <div class="d-md-flex align-items-center justify-content-between">
                            <h2 class="c-ttl c-ttl--mdp fw-b">You need a lift to the port?</h2>

                            <button class="btn btn-white-alt-sec is-smaller txt-init mt-3 mt-md-0" @click="skip">Continue without transfer</button>
                        </div>

                        <template v-if="transfersAllowed && availableTransfers.length">
                            <section class="o-bk-box b1 p-0 box-sh bg-white is-rounded mt-4">
                                <div class="d-flex px-3 align-items-center">
                                    <span class="icon-location fs-20 cl-light mr-2"></span>
                                    <input type="text" ref="autocomplete" class="form-control border-0 map-search-input" placeholder="Find your location to see the transfer points nearby" />
                                </div>

                                <div class="o-bk-pickup-map">
                                    <div id="transfers-map"></div>
                                </div>
                            </section>

                            <div class="c-section">
                                <div class="d-md-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <span class="icon-boat-filled fs-24 cl-sec-l mr-2"></span>Select a transfer
                                    </div>

                                    <div class="text-right mt-2 mt-md-0">Price</div>
                                </div>

                                    <div id="transfers-list"
                                        class="o-bk-ticket-list"
                                        :class="{ 'ticket-selected': selectedTransfer }">
                                        <div
                                            v-for="transfer in availableTransfers"
                                            v-bind:key="transfer.id"
                                            :id="'transfer-'+transfer.id"
                                            class="o-bk-ticket is-pickup"
                                            :class="{
                                                'is-selected': selectedTransfer == transfer.id
                                            }"
                                            @click="selectTransfer(transfer.id)">
                                            <span class="o-bk-ticket__check icon-check"></span>

                                            <div class="o-bk-ticket__shadow">
                                                <div></div>
                                                <div></div>
                                            </div>

                                            <div class="o-bk-ticket__inner is-rounded bg-white">
                                                <div class="o-bk-ticket__body">
                                                    <div class="d-md-flex">
                                                        <div>
                                                            <strong class="c-ttl--md">{{ transfer.time }}</strong>
                                                        </div>

                                                        <div class="mt-2 mt-md-0 pl-md-5">
                                                            <h2 class="c-ttl c-ttl--md cl-sec-l">{{ transfer.name }}</h2>

                                                            <div class="mb-0 mt-1 cl-dark fs-14" v-html="transfer.description"></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="o-bk-ticket__price">
                                                    <strong class="is-price c-ttl--mdp d-block">{{ transfer.price ? currency(transfer.price) : 'FREE' }}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </template>
                        
                        <div class="o-bk-box box-sh bg-white is-rounded mt-4 text-center" v-else>
                            <loader v-if="loading" />
                            <template v-if="!transfersAllowed">
                                Transfers are not available with the {{ supplementsWithoutTransfer.length > 1 ? 'supplements' : 'supplement' }} you selected ({{ supplementsWithoutTransfer.join(', ') }}).
                            </template>
                            <template v-else-if="!loading && !availableTransfers.length">
                                There are no available transfers matching your booking criteria
                            </template>
                        </div>

                        <div class="d-md-flex align-items-center justify-content-between mt-4 pt-2">
                            <button class="btn btn-white-alt-sec bg-white is-wide mr-3 mb-3" @click="previousStep">Back</button>
                            <button class="btn btn-primary is-wide mb-3" type="button" @click="submit">Continue</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Loader from '../components/Loader.vue'
export default {
  components: { Loader },
    data() {
        return {
            availableTransfers: [],
            map: null,
            markers: [],
            iconBase: window.venezialines.theme_root+'/assets/media/icons/',
            placesService: null,
            transfersAllowed: true,
            supplementsWithoutTransfer: [],
            loading: false,
            searchResultMarker: null,
        }
    },
    computed: {
        ...mapState('booking', [
            'legs',
            'specialOffer',
            'passengersCount',
            'availableSupplements',
            'supplements',
        ]),
        selectedTransfer() {
            return this.$store.state.booking.transfer
        },
        locations() {
            return this.availableTransfers.filter(transfer => !(transfer.lat === null || transfer.lng === null)).map(transfer => {
                return { id: transfer.id, lat: transfer.lat, lng: transfer.lng, name: transfer.name }
            })
        }
    },
    mounted() {
        // Check if transfers are allowed with selected supplements
        if (this.supplements.length) {
            this.supplements.forEach(supplement => {
                let supplementDetails = this.availableSupplements.find(s => s.id == supplement.id)
                if (!supplementDetails.transfers) {
                    this.transfersAllowed = false
                    this.supplementsWithoutTransfer.push(supplementDetails.name)
                }
            })
        }

        if (this.transfersAllowed) {
            this.getAvailableTransfers()
        }
    },
    methods: {
        ...mapActions('booking', [
            'previousStep',
            'nextStep',
            'setTransfer',
            'updateBooking',
        ]),
        skip() {
            this.setTransfer(null)
            this.submit()
        },
        submit() {
            this.updateBooking(['transfers'])
        },
        getAvailableTransfers() {
            this.loading = true
            this.$api.transfers({
                out_origin_id: this.legs.out.origin,
                out_destination_id: this.legs.out.destination,
                out_trip_id: this.legs.out.trip.id,
                special_offer_id: this.specialOffer ? this.specialOffer.id : null,
                ret_origin_id: this.legs.ret.origin,
                ret_destination_id: this.legs.ret.destination,
                ret_trip_id: this.legs.ret.trip.id,
            }).then(response => {
                Object.keys(response.out).forEach(port => {
                    response.out[port].forEach(outTransfer => {
                        let retPort = (port == 'origin') ? 'destination' : 'origin'
                        let retTransfer = response.ret[retPort].find(transfer => transfer.id == outTransfer.id)
                        if (retTransfer) {
                            let price = 0
                            Object.keys(this.passengersCount).forEach(category => {
                                price += (parseFloat(this.passengersCount[category]) * parseFloat(outTransfer.price[category.toUpperCase()] || 0))
                                price += (parseFloat(this.passengersCount[category]) * parseFloat(retTransfer.price[category.toUpperCase()] || 0))
                            })
                            this.availableTransfers.push({...outTransfer, price: price})
                        }
                    })
                })
                this.loading = false
                this.$nextTick(() => this.initMap())
            })
        },
        selectTransfer(transferId) {
            this.markers.forEach((marker, index) => {
                marker.setIcon(this.iconBase + 'google-marker-inactive.svg')
                marker.setZIndex(100+index)
            })

            if (transferId && (transferId == this.selectedTransfer)) {
                this.setTransfer(null)
            } else {
                this.setTransfer(transferId)

                if (transferId) {
                    let marker = this.markers.find(marker => marker.id == transferId)
                    marker.setIcon(this.iconBase + 'google-marker-active.svg')
                    marker.setZIndex(100+this.markers.length)
                    this.map.setZoom(14)
                    this.map.panTo(marker.getPosition())
                    this.$scrollTo('#transfer-'+marker.id, {
                        container: '#transfers-list',
                    })
                }
            }
        },
        initMap() {
            const MAP_BOUNDS = {
                west: 10.5,
                east: 19.5,
                north: 46.6,
                south: 42.3,
            }

            let mapCenterPosition = {lat: 45.19691523137467, lng: 13.053600253925152 };
            let map = new google.maps.Map(document.getElementById('transfers-map'), {
                zoom: 9,
                center: mapCenterPosition,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                draggable: true,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                restriction: {
                    latLngBounds: MAP_BOUNDS,
                    strictBounds: true,
                }
            });

            this.map = map

            this.setMapMarkers()
            this.placesService = new google.maps.places.PlacesService(this.map)
            const autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete, {
                componentRestrictions: { country: "hr" },
                fields: ['formatted_address', "geometry.location", "name"],
            })

            this.searchResultMarker = new google.maps.Marker({
                id: 'searchResult',
                map: this.map,
                animation: google.maps.Animation.DROP,
                visible: false
            })

            autocomplete.addListener("place_changed", () => {
                const place = autocomplete.getPlace()
                this.searchResultMarker.setVisible(false)

                if (place.name && place.geometry && place.formatted_address) {
                    const components = place.formatted_address.split(', ')
                    const country = components[components.length - 1].trim()
                    if (country == 'Croatia') {
                        this.map.setZoom(13)
                        this.map.panTo(place.geometry.location)
                        this.searchResultMarker.setPosition(place.geometry.location)
                        this.searchResultMarker.setVisible(true)
                        return
                    }
                }

                this.findTransfer(place.name)
            })

        },
        setMapMarkers() {
            let marker, i, latLng;
            let location
            let that = this
            let bounds = new google.maps.LatLngBounds()

            for (i = 0; i < this.locations.length; i++) {
                location = this.locations[i] 
                latLng = new google.maps.LatLng(location.lat, location.lng)
                marker = new google.maps.Marker({
                    id: location.id,
                    position: latLng,
                    map: this.map,
                    clickable: true,
                    icon: this.iconBase + 'google-marker-inactive.svg',
                    animation: google.maps.Animation.DROP,
                    title: location.name,
                    zIndex: 100+i,
                });
                this.markers.push(marker);
                bounds.extend(latLng)

                google.maps.event.addListener(marker, 'click', (function(marker, i) {
                    return function() {
                        that.selectTransfer(marker.id)
                        //Booking.selectTicketByPickupLocation(locations[i][0]);
                    }
                })(marker, i));
            }

            this.markers.length && this.map.fitBounds(bounds)
            
            //$('.js-ticket').on('click', function () {
            //let location = $(this).data('pickup-location');
            //
            //for (let j = 0; j < markers.length; j++) {
            //    if (locations[j][0] === location) {
            //    markers[j].setIcon(this.iconBase + 'google-marker-active.svg');
            //    } else {
            //    markers[j].setIcon(this.iconBase + 'google-marker-inactive.svg');
            //    }
            //    
            //}
            //});
        },
        findTransfer(term) {
            const transfer = this.availableTransfers.find(transfer => {
                if (!transfer.lat || !transfer.lng) return false
                return transfer.name.toLowerCase().includes(term.toLowerCase())
                    || transfer.description.toLowerCase().includes(term.toLowerCase())
            })

            if (transfer) {
                const position = new google.maps.LatLng(transfer.lat, transfer.lng)
                this.searchResultMarker.setPosition(position)
                this.map.panTo(position)
                this.map.setZoom(13)
                this.searchResultMarker.setVisible(true)
            } else {
                this.$swal('Error', 'Location could not be found', 'error')
            }
        },
    }
}
</script>

<style scoped>
input.map-search-input {
    font-size: 1rem;
}
input.map-search-input::placeholder {
    color: #aaa;
}
#transfers-list {
  max-height: 60vh;
  overflow: scroll;
  margin: 25px -30px 0;
  padding: 0 30px;
}
@media (max-width: 1199px) {
    #transfers-list::-webkit-scrollbar {
        display: none;
    }
    #transfers-list {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
}
@media (max-width: 1024px) {
    #transfers-list {
        margin: 25px -10px 0;
        padding: 0 10px;
        max-height: 80vh;
    }
}

</style>